import React from "react";
import { Input } from "reactstrap";
import { languageService } from "../../../Language/language.service";
import { ButtonActionsTable } from "../../Common/Buttons";

/**
 * Generates columns for the Materials table inside the Reservation modal.
 * @param {Object} context - The component context (this) or relevant handlers/state.
 */
export const getMaterialsTableColumns = (context) => {
  const { modalMode, materials, updateItemField, removeItemRow } = context;
  const isView = modalMode === "View";
  const isTransaction = modalMode === "Issue" || modalMode === "Return";
  const isReadOnly = isView || isTransaction;

  const tableColumns = [
    {
      Header: languageService("Item (SKU)"),
      accessor: "sku",
      Cell: (cell) =>
        isReadOnly ? (
          <span>{cell.original.sku}</span>
        ) : (
          <Input
            type="select"
            value={cell.original.sku}
            onChange={(e) => updateItemField(cell.index, "sku", e.target.value)}
            className="reservation-table-input"
          >
            <option value="">{languageService("-- Select Item --")}</option>
            {materials.map((m) => (
              <option key={m.code} value={m.code}>
                {m.code}
              </option>
            ))}
          </Input>
        ),
    },
  ];

  if (!isReadOnly) {
    tableColumns.push({
      Header: languageService("Quantity"),
      accessor: "quantityRequested",
      Cell: (cell) => (
        <Input
          type="number"
          min="1"
          value={cell.original.quantityRequested}
          onChange={(e) => updateItemField(cell.index, "quantityRequested", e.target.value)}
          className="reservation-table-input"
        />
      ),
    });
  }

  if (isView || modalMode === "Return") {
    tableColumns.push(
      {
        Header: languageService("Reserved"),
        accessor: "quantityReserved",
        Cell: (row) => <span>{row.value || 0}</span>,
      },
      {
        Header: languageService("Issued"),
        accessor: "quantityIssued",
        Cell: (row) => <span>{row.value || 0}</span>,
      },
      {
        Header: languageService("Returned"),
        accessor: "quantityReturned",
        Cell: (row) => <span>{row.value || 0}</span>,
      },
    );
  }

  if (modalMode === "Return") {
    tableColumns.push({
      Header: languageService("Return Now"),
      accessor: "quantityToReturn",
      Cell: (cell) => (
        <Input
          type="number"
          min="0"
          max={(cell.original.quantityIssued || 0) - (cell.original.quantityReturned || 0)}
          value={cell.original.quantityToReturn || 0}
          onChange={(e) => updateItemField(cell.index, "quantityToReturn", e.target.value)}
          className="reservation-table-input"
        />
      ),
    });
  }

  if (modalMode === "Issue") {
    tableColumns.push({
      Header: languageService("Issue Now"),
      accessor: "quantityToIssue",
      Cell: (cell) => (
        <Input
          type="number"
          min="0"
          max={(cell.original.quantityReserved || 0) - (cell.original.quantityIssued || 0)}
          value={cell.original.quantityToIssue || 0}
          onChange={(e) => updateItemField(cell.index, "quantityToIssue", e.target.value)}
          className="reservation-table-input"
        />
      ),
    });
  }

  if (!isView && !isTransaction) {
    tableColumns.push({
      Header: languageService("Action"),
      accessor: "actions",
      width: 100,
      Cell: (cell) => (
        <div style={{ textAlign: "center", width: "100%" }}>
          <ButtonActionsTable handleClick={() => removeItemRow(cell.index)} buttonText={languageService("Delete")} />
        </div>
      ),
    });
  }

  return tableColumns;
};



// WEBPACK FOOTER //
// ./src/components/IMS/Reservation/reservationMaterialsColumns.js